<section class="mt-4" >
  <div *ngIf="data" matBadge="{{data.length}}" matBadgeColor="warn" matBadgeOverlap="false" matBadgePosition="after"></div>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="h6" i18n>Slávnosti</div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div *ngIf="data">
      <app-slavnost *ngFor="let s of data" [slavnost]="s"></app-slavnost>
    </div>
    <hr/>
    <div class="d-flex flex-row align-items-center">
      <b><a (click)="appOpen()" i18n i18n-title title="Prihlásiť sa na slávnosť">Prihlásiť sa na slávnosť</a></b>
    </div>
  </mat-expansion-panel>
</section>
